// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.checkbox-option {
  margin-bottom: 0.5rem;
}

::ng-deep .mat-mdc-checkbox.feature-checkbox,
::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox,
::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox__ripple {
  --mdc-checkbox-selected-icon-color: #d4af37;
  --mdc-checkbox-selected-hover-icon-color: black;
  --mdc-checkbox-selected-focus-icon-color: black;
  --mdc-checkbox-selected-pressed-icon-color: #d4af37;
  --mdc-checkbox-selected-hover-state-layer-color: rgba(212,175,55,0.1);
  --mdc-checkbox-selected-focus-state-layer-color: rgba(212,175,55,0.1);
  --mdc-checkbox-selected-pressed-state-layer-color: rgba(212,175,55,0.1);
  --mdc-checkbox-unselected-hover-icon-color: #d4af37;
  --mdc-checkbox-unselected-hover-state-layer-color: rgba(212,175,55,0.1);
}

::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox__ripple::before {
  background-color: rgba(212, 175, 55, 0.1) !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/listing-form-styles/listing-form-checkbox.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;;;EAGE,2CAAA;EACA,+CAAA;EACA,+CAAA;EACA,mDAAA;EAEA,qEAAA;EACA,qEAAA;EACA,uEAAA;EAEA,mDAAA;EACA,uEAAA;AADF;;AAIA;EACE,oDAAA;AADF","sourcesContent":[".checkbox-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.checkbox-option {\n  margin-bottom: 0.5rem;\n}\n\n::ng-deep .mat-mdc-checkbox.feature-checkbox,\n::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox,\n::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox__ripple {\n  --mdc-checkbox-selected-icon-color: #d4af37;\n  --mdc-checkbox-selected-hover-icon-color: black;\n  --mdc-checkbox-selected-focus-icon-color: black;\n  --mdc-checkbox-selected-pressed-icon-color: #d4af37;\n\n  --mdc-checkbox-selected-hover-state-layer-color: rgba(212,175,55,0.1);\n  --mdc-checkbox-selected-focus-state-layer-color: rgba(212,175,55,0.1);\n  --mdc-checkbox-selected-pressed-state-layer-color: rgba(212,175,55,0.1);\n\n  --mdc-checkbox-unselected-hover-icon-color: #d4af37;\n  --mdc-checkbox-unselected-hover-state-layer-color: rgba(212,175,55,0.1);\n}\n\n::ng-deep .mat-mdc-checkbox.feature-checkbox .mdc-checkbox__ripple::before {\n  background-color: rgba(212, 175, 55, 0.1) !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
